// saveBase — the save id the editor's buffer is currently based on.
//
// Set to the tip we LOADED (on open) and the tip we CREATED (on each save).
// Sent as `previousSaveId` on the next save so the backend can detect a
// concurrent save (someone else advanced the tip) and reply 409 STALE_BASE,
// which the editor turns into a reconcile (take-theirs / keep-mine) instead of
// silently forking the save history. Null ⇒ send nothing ⇒ old last-write-wins
// behaviour (safe fallback, no false conflicts). See RECONCILIATION-STRATEGY §6.1.

let baseSaveId: string | null = null;

export function setBaseSaveId(id: string | null): void {
  baseSaveId = id;
}

export function getBaseSaveId(): string | null {
  return baseSaveId;
}
